import React from "react";
import "./style.css";
import { Title } from "../Title";
import { VinylCard } from "./VinylCard";

export const Albuns = ({ className, content }) => {
  const albumCovers = [
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_06.jpg",
      link: "#",
    },
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_05.jpg",
      link: "#",
    },
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_04.jpg",
      link: "#",
    },
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_03.jpg",
      link: "#",
    },
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_02.jpg",
      link: "#",
    },
    {
      coverSrc:
        "https://demo.farost.net/backtorock/wp-content/uploads/2018/03/album_01.jpg",
      link: "#",
    },
  ];
  const albuns = content.albums.map((album, index) => ({
    ...albumCovers[index],
    ...album,
  }));

  return (
    <section id="albuns" className={`albuns ${className} position-relative`}>
      <div className="container">
        <Title
          title={content.sections.albums.title}
          description={content.sections.albums.description}
        />
        <div className="row align-items-center justify-content-between">
          {albuns.map((item, index) => (
            <div className="col-xl-4 col-6" key={`${item.name}-${index}`}>
              <div className="vinyl__item position-relative">
                <VinylCard
                  coverSrc={item.coverSrc}
                  link={item.link}
                  artist={item.artist}
                  name={item.name}
                  year={item.year}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
